module.exports = __webpack_public_path__ + "static/img/product_11.22e523c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_11.png
// module id = zdzN
// module chunks = 2